<template>
  <div class="tab-box">
    <div class="tab-title">全部分类</div>
    <div class="tab-list">
      <div class="tab-item" v-for="(item, index) in list" :key="index" @click="onList(item)">{{ item.text }}</div>
    </div>
  </div>
</template>

<script>
import { getCategoryList } from "@/api/category"
export default {
  name: 'Category',
  data() {
    return {
      list: []
    }
  },
  created() {
    this._getList()
  },
  methods: {
    onList(item) {
      this.$router.push({name: 'list', query: {id: item.id}})
    },
    _getList() {
      getCategoryList().then(res => {
        if (res.code === 200 && res.data) {
          this.list = res.data
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-box {
  width: 280px;
  .tab-title {
    height: 35px;
    font-size: 18px;
    line-height: 25px;
    font-weight: 700;
    padding-left: 6px;
  }
  .tab-list {
    background: #fff;
    border: 1px solid #e5e5e5;
    padding: 0 10px 20px 10px;
    border-radius: 5px;
    .tab-item {
      cursor: pointer;
      height: 44px;
      border-bottom: 1px dotted #eaeaea;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
    }
  }
}
</style>